import Dashboard from "../views/Dashboard/Dashboard";
import UserProfile from "../views/UserProfile/UserProfile";
import Schedule from "../views/Schedule/Schedule";
import Availability from "../views/Availability/Availability";
import Forms from "../views/Forms/Forms";
import UpdatePassword from "../views/Account/UpdatePassword";

const dashboardRoutes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: "pe-7s-graph",
    component: Dashboard
  },
  {
    path: "/user",
    name: "Installer Profile",
    icon: "pe-7s-user",
    component: UserProfile
  },
  {
    path: "/schedule",
    name: "Schedule",
    icon: "pe-7s-date",
    component: Schedule
  },
  {
    path: "/availability",
    name: "Availability",
    icon: "pe-7s-car",
    component: Availability
  },
  {
    path: "/forms",
    name: "Forms",
    icon: "pe-7s-note2",
    component: Forms
  },
  {
    path: "/updatepassword",
    name: "Update Password",
    icon: "pe-7s-lock",
    component: UpdatePassword
  },
  { redirect: true, path: "/", to: "/dashboard", name: "Dashboard" }
];

export default dashboardRoutes;



// WEBPACK FOOTER //
// ./src/routes/dashboard.jsx